<template>
  <div>
    <v-row justify="center" align="center">
      <v-col cols="12" md="12" sm="12">
        <v-banner icon="mdi-card-search-outline">Your Orders</v-banner>
      </v-col>

      <v-col cols="12" md="12" sm="12">
        <v-row justify="center" align="start">
          <v-col cols="12" md="3" sm="12">
            <v-form v-model="valid" @submit.prevent="loadExistingOrders">
              <v-text-field
                dense
                outlined
                v-model="numberOfDays"
                label=" No. of days"
                class="shrink"
                :rules="[required('No. of Days'), isValidNumber]"
                @focus="$event.target.select()"
                color="blue darken-2"
                type="number"
                :hint="`Load orders from the past ${this.numberOfDays} days`"
                persistent-hint
              ></v-text-field>
            </v-form>
          </v-col>
          <v-col cols="12" md="9" sm="12">
            <v-btn
              block
              outlined
              color="blue darken-2"
              large
              @click.stop="loadExistingOrders"
              :loading="loadingOrders"
            >
              <v-icon class="mr-2">refresh</v-icon>Refresh
            </v-btn>
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="12" md="12" sm="12">
        <v-data-table
          :headers="headers"
          :items="orders"
          item-key="td_id"
          class="elevation-0"
          :loading="loadingOrders"
          loading-text="Loading your orders..."
          :items-per-page="15"
          single-expand
          show-expand
          :footer-props="{
            showFirstLastPage: true,
            firstIcon: 'mdi-arrow-collapse-left',
            lastIcon: 'mdi-arrow-collapse-right',
            prevIcon: 'mdi-minus',
            nextIcon: 'mdi-plus',
          }"
          @click:row="(item, slot) => slot.expand(!slot.isExpanded)"
        >
          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length" class="pa-2">
              <v-data-table
                hide-default-footer
                style="text-transform: capitalize"
                class="expansionColour elevation-0"
                :headers="subTableHeaders"
                :items="Object.values(item.tickets)"
                item-key="tdd_id"
              >
                <template v-slot:item.distName="{ item }">
                  <span class="font-weight-medium">{{
                    item.distributor_name
                  }}</span>
                </template>
                <template v-slot:item.invoiceNo="{ item }">
                  <span class="font-weight-medium">{{ item.invoice_no }}</span>
                </template>
                <template v-slot:item.invoiceTotal="{ item }">
                  <span v-if="retrieveShowPrices" class="font-weight-medium">
                    £
                    {{
                      parseFloat(item.net_total + item.vat_total).toFixed(2)
                    }}</span
                  >
                </template>
                <template v-slot:item.actionsCol="{ item }">
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        icon
                        color="blue darken-2"
                        v-on="on"
                        @click.stop="goToDetailsPage(item)"
                      >
                        <v-icon>info</v-icon>
                      </v-btn>
                    </template>
                    <span>More Information</span>
                  </v-tooltip>
                </template>
              </v-data-table>
            </td>
          </template>

          <!--Table Rows---->
          <template v-slot:item.deliveryDate="{ item }">
            <span>
              <span class="font-weight-medium">{{
                getFormatedDate(item.transaction_date)
              }}</span>
              <br />
            </span>
          </template>
          <template v-slot:item.total="{ item }">
            <span v-if="retrieveShowPrices">
              <span class="font-weight-medium">
                £
                {{
                  parseFloat(item.net_total + item.vat_total).toFixed(2)
                }}</span
              >
              <br />
            </span>
          </template>
          <template v-slot:item.ticketStatus="{ item }">
            <span>
              <span class="font-weight-medium">{{
                getOrderStatus(item, item.tickets)
              }}</span>
              <br />
            </span>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-tooltip
              top
              v-if="
                (item.locked == '1' &&
                  item.payment_found == false &&
                  item.payment_success == null) ||
                (item.locked == '1' && item.payment_success == '0')
              "
            >
              <template v-slot:activator="{ on }">
                <v-btn
                  icon
                  color="blue darken-2"
                  v-on="on"
                  @click.stop="goToPaymentPage(item)"
                >
                  <v-icon>payment</v-icon>
                </v-btn>
              </template>
              <span>Make Payment</span>
            </v-tooltip>
            <v-tooltip top v-if="item.locked == '0'">
              <template v-slot:activator="{ on }">
                <v-btn
                  icon
                  color="blue darken-2"
                  v-on="on"
                  @click.stop="resendEmail(item.td_id)"
                >
                  <v-icon>mail</v-icon>
                </v-btn>
              </template>
              <span>Resend Email</span>
            </v-tooltip>
            <!-- <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn icon color="blue darken-2" v-on="on" @click.stop="goToDetailsPage(item)">
                  <v-icon>info</v-icon>
                </v-btn>
              </template>
              <span>More Information</span>
            </v-tooltip> -->

            <v-tooltip top v-if="isAccountCustomer">
              <template v-slot:activator="{ on }">
                <v-btn
                  icon
                  color="teal base"
                  v-on="on"
                  :to="{ name: 'RecreateOrder', params: { td_id: item.td_id } }"
                >
                  <v-icon>file_copy</v-icon>
                </v-btn>
              </template>
              <span>Recreate Order</span>
            </v-tooltip>

            <v-tooltip
              top
              v-if="
                (item.locked == '1' &&
                  item.payment_found == false &&
                  item.payment_success == null) ||
                (item.locked == '1' && item.payment_success == '0')
              "
            >
              <template v-slot:activator="{ on }">
                <v-btn
                  icon
                  color="error darken-1"
                  v-on="on"
                  @click="showVoidDialog(item.td_id)"
                >
                  <v-icon>delete_forever</v-icon>
                </v-btn>
              </template>
              <span>Void Order</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <v-dialog v-model="voidOrderDialog" persistent max-width="400">
      <v-card>
        <v-card-title>
          Void Order
          <v-spacer />
          <v-btn icon @click="hideVoidDialog()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text
          >This will permanently remove your order, you will not be able to
          retrieve this order once voided, Are you sure?</v-card-text
        >
        <v-card-actions class="dialogActions">
          <v-btn text @click="hideVoidDialog()">Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            :loading="voidLoading"
            color="error darken-1"
            outlined
            @click="voidItem()"
            >Void</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import moment from "moment";

export default {
  name: "OrdersYourOrders",
  data: () => {
    return {

      headers: [
        // { text: "Transaction ID", value: "id" },
        { text: "Delivery Date", value: "deliveryDate", sortable: false },
        { text: "Order Total", value: "total", sortable: false },
        { text: "Status", value: "ticketStatus", sortable: false },
        { text: "Actions", value: "actions", sortable: false },
      ],
      subTableHeaders: [
        { text: "Distributor Name", value: "distName", sortable: false },
        { text: "Ticket No", value: "invoiceNo", sortable: false },
        { text: "Ticket Total", value: "invoiceTotal", sortable: false },
        { text: "Actions", value: "actionsCol", sortable: false },
      ],
      voidOrderDialog: false,
      tdidToVoid: null,
      voidLoading: false,
      loadingOrders: false,
      orders: [],

      required(fieldName) {
        return (v) => (v && v.length > 0) || `${fieldName} Required`;
      },
      isValidNumber: (v) => {
        return (
          /^([1-9]|[1-8][0-9]|9[0-9]|[12][0-9]{2}|3[0-5][0-9]|36[0-5])$/.test(
            v
          ) || "Number must be valid"
        );
      },
      valid: false,
      numberOfDays: 90,
    };
  },

  computed: {

    ...mapGetters(["retrieveShowPrices"]),

    isAccountCustomer() {
      if (
        !this.$store.getters.retrieveIsCncCustomer &&
        !this.$store.getters.retrieveIsCashCustomer
      ) {
        return true;
      } else {
        return false;
      }
    },
  },

  methods: {
    ...mapActions([
      "fetchExistingOrders",
      "sendEmail",
      "voidOrder",
      "clearOrderProducts",
      "clearOrderTickets",
      "orderBeingPaidForAction",
      "setSnackbar",
    ]),

    async loadExistingOrders() {
      this.loadingOrders = true;
      this.orders = [];

      let response = await this.fetchExistingOrders({
        daysPast: this.numberOfDays,
      });

      console.log(response);

      if (response) {
        this.clearOrderProducts();
        this.clearOrderTickets();

        this.orders = this.$store.state.ordersHistory.orders;
      } else {
        console.log("error fetchig orders");
      }

      this.loadingOrders = false;
    },

    getInvoiceNo(ticket) {
      if (ticket) {
        return Object.keys(ticket)[0];
      } else {
        return "";
      }
    },

    hasMultipleInvoices(order) {
      return Object.keys(order.tickets).length > 1;
    },
    getOrderStatus(order, ticket) {
      let invoice = this.getInvoiceNo(ticket);
      if (order) {
        let statusCode = order.tickets[invoice].status;
        if (
          order.locked == 1 &&
          order.payment_found == true &&
          order.payment_success == "0"
        ) {
          return "Payment Failed";
        } else if (
          order.locked == 1 &&
          order.payment_found == false &&
          order.payment_success == null
        ) {
          return "Awaiting Payment";
        } else if (
          order.locked == 1 &&
          order.payment_found == true &&
          order.payment_success == null
        ) {
          return "Processing Payment";
        }
        if (statusCode == 1) {
          return "Order Entered";
        } else if (statusCode == 2) {
          return "Order Picked";
        } else if (statusCode == 3) {
          return "Order Dispatched";
        } else if (statusCode == 4) {
          return "Order Invoiced";
        } else {
          return "Order";
        }
      } else {
        return "";
      }
    },
    resendEmail(tdId) {
      this.sendEmail(tdId)
        .then((response) => {
          if (response.success == true) {
            this.setSnackbar({ text: "Email Sent Successfully" });
            console.log("Sent Email successfully");
          } else {
            this.setSnackbar({ color: "error", text: response.message });
            console.log("Sending failed");
          }
        })
        .catch((er) => {
          console.log(er);
        });
    },

    showVoidDialog(tdId) {
      console.log("-- TD ID to void");
      this.tdidToVoid = tdId;
      console.log(this.tdidToVoid);
      this.voidOrderDialog = true;
    },

    hideVoidDialog() {
      console.log("-- TD ID to void");
      this.tdidToVoid = null;
      this.voidOrderDialog = false;
    },

    voidItem() {
      console.log("Void ORder");
      console.log(this.tdidToVoid);

      this.voidLoading = true;

      this.voidOrder(this.tdidToVoid)
        .then((response) => {
          if (response.success == true) {
            this.setSnackbar({ text: "Order Voided" });
            this.loadExistingOrders();
          } else {
            this.setSnackbar({ color: "error", text: response.message });
          }

          this.voidOrderDialog = false;
          this.voidLoading = false;
        })
        .catch((er) => {
          console.log(er);
          this.voidOrderDialog = false;
          this.voidLoading = false;
          this.setSnackbar({
            color: "error",
            text: "Order Not Voided: Connection to server lost",
          });
        });
    },

    getFormatedDate(deliveryDate) {
      return moment(deliveryDate).format("dddd, MMMM Do YYYY");
    },
    getOrderProducts(tdId) {
      this.$store
        .dispatch("fetchOrdersProducts", { tdId: tdId })
        .then((response) => {
          if (response == true) {
            console.log("Products Found And Retrieved");
          } else {
            console.log("Failed to retreive Order Products");
          }
        })
        .catch((er) => {
          console.log(er);
        });
    },
    goToDetailsPage(orderTicket) {
      this.getOrderProducts(orderTicket.tdd_id);
      this.$router.push({
        name: "TicketDetails",
        params: {
          invoice_no: orderTicket.invoice_no,
          ticket: orderTicket,
        },
      });
    },

    goToPaymentPage(order) {
      //set store for orderBeingPaidFor
      const rec = {
        orderId: order.td_id,
        orderAmount: order.net_total + order.vat_total,
      };
      this.orderBeingPaidForAction(rec);
      this.$router.push({ name: "OrderPayment" });
      //redirect
    },
  },
  activated() {
    this.loadExistingOrders();
  },
};
</script>

<style lang="sass">
.theme--light .v-data-table tbody tr.v-data-table__expanded__content
  box-shadow: none
  background: #f3f4f7

.theme--light .expansionColour, .theme--light .expansionColour table th, .theme--light .expansionColour table td
  background: #f3f4f7 !important

.theme--dark .v-data-table tbody tr.v-data-table__expanded__content
  box-shadow: none
  background: #1b1b1b

.theme--dark .expansionColour, .theme--dark .expansionColour table th, .theme--dark .expansionColour table td
  background: #1b1b1b !important
</style>